import { http } from "./http";

export function requestCustomerRegisterCode(email: string) {
  return http<{ ok: true; expiresInMinutes: number }>(
    `/customer-auth/register/request-code`,
    {
      method: "POST",
      body: { email },
    }
  );
}

export function checkCustomerRegisterCpf(cpf: string) {
  return http<{ available: boolean }>(`/customer-auth/register/check-cpf`, {
    method: "POST",
    body: { cpf },
  });
}

export function verifyCustomerRegisterCode(email: string, code: string) {
  return http<{ ok: true }>(`/customer-auth/register/verify-code`, {
    method: "POST",
    body: { email, code },
  });
}

export function registerCustomer(payload: {
  email: string;
  password: string;
  code: string;
  fullName: string;
  cpf: string;
  phone?: string;
  whatsapp: string;
  birthDate?: string | null;
  photoUrl?: string | null;
  establishmentId?: string | null;
  establishmentSlug?: string | null;
}) {
  return http<{ id: string; email: string }>(`/customer-auth/register`, {
    method: "POST",
    body: payload,
  });
}

export function loginCustomer(email: string, password: string) {
  return http<{ token: string }>(`/customer-auth/login`, {
    method: "POST",
    body: { email, password },
  });
}

/**
 * MBR-15: login sem senha. O pedido responde sempre igual (neutro), exista a
 * conta ou não; o código vale 10 minutos.
 */
export function requestCustomerLoginCode(email: string) {
  return http<{ ok: true; expiresInMinutes: number }>(
    `/customer-auth/login/request-code`,
    {
      method: "POST",
      body: { email },
    }
  );
}

/**
 * Devolve o mesmo token do login por senha. Erros: 400
 * `INVALID_OR_EXPIRED_CODE` e 429 `TOO_MANY_ATTEMPTS` (o código foi invalidado).
 */
export function verifyCustomerLoginCode(email: string, code: string) {
  return http<{ token: string }>(`/customer-auth/login/verify-code`, {
    method: "POST",
    body: { email, code },
  });
}

export function requestCustomerPasswordReset(email: string) {
  return http<{ ok: true; expiresInMinutes: number }>(
    `/customer-auth/password/request-reset`,
    {
      method: "POST",
      body: { email },
    }
  );
}

export function verifyCustomerPasswordReset(email: string, code: string) {
  return http<{ ok: true }>(`/customer-auth/password/verify-reset`, {
    method: "POST",
    body: { email, code },
  });
}

export function resetCustomerPassword(email: string, code: string, newPassword: string) {
  return http<{ ok: true }>(`/customer-auth/password/reset`, {
    method: "POST",
    body: { email, code, newPassword },
  });
}

export function getCustomerMe(token: string) {
  return http<{
    id: string;
    email: string;
    fullName: string | null;
    cpf: string | null;
    phone: string | null;
    whatsapp: string | null;
    birthDate: string | null;
    photoUrl: string | null;
    active: boolean;
  }>(`/customer-auth/me`, { token });
}

export function updateCustomerMe(
  token: string,
  payload: {
    fullName?: string;
    cpf?: string;
    phone?: string | null;
    whatsapp?: string | null;
    birthDate?: string | null;
    photoUrl?: string | null;
  }
) {
  return http<{
    ok: boolean;
    customer: {
      id: string;
      email: string;
      fullName: string | null;
      cpf: string | null;
      phone: string | null;
      whatsapp: string | null;
      birthDate: string | null;
      photoUrl: string | null;
    } | null;
  }>(`/customer-auth/me`, {
    method: "PUT",
    token,
    body: payload,
  });
}

export function changeCustomerPassword(
  token: string,
  payload: { currentPassword: string; newPassword: string }
) {
  return http<{ ok: true }>(`/customer-auth/change-password`, {
    method: "POST",
    token,
    body: payload,
  });
}
